import { DecimalPipe, I18nPluralPipe, JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { WireItemDetails } from '@idealsupply/products-api-angular-client';
import { ProductContainerUnitLabels, ProductUnitLabels, WithItemId } from 'products-data';

@Component({
  selector: 'ideal-wire-cut-item-description-view',
  imports: [I18nPluralPipe, DecimalPipe, JsonPipe],
  standalone: true,
  templateUrl: './wire-cut-item-description-view.component.html',
  styleUrl: './wire-cut-item-description-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WireCutItemDescriptionViewComponent {
  public readonly item = input.required<WithItemId<WireItemDetails> | undefined>();

  protected readonly sizeCodeOption = computed(() => this.item()?.id.options.get(0) ?? null);
  protected readonly sizeCode = computed(() => this.sizeCodeOption()?.name ?? '');
  protected readonly isCustom = computed(() => this.sizeCode() === 'Z');
  protected readonly size = computed(() => (this.isCustom() ? +(this.item()!.id.options.value('Z') || 0) : this.item()?.size) ?? 1);

  protected readonly unit = computed(() => this.item()?.unit?.toLowerCase() ?? 'mr');
  protected readonly containerUnit = computed(() => this.item()?.containerUnit?.toLowerCase() ?? 'roll');
  protected readonly unitLabel = computed(() => ProductUnitLabels[this.unit() as keyof typeof ProductUnitLabels] ?? ProductUnitLabels.ea);
  protected readonly containerUnitLabel = computed(
    () => ProductContainerUnitLabels[this.containerUnit() as keyof typeof ProductContainerUnitLabels] ?? ProductContainerUnitLabels.roll,
  );
}
